import { TkCheckboxProps } from "../../../type/componentsType/TkCheckbox";

const documentList: {
  label: string; // ボタン表示名
  path?: string; // PDFファイルパス
  link?: string; // 外部リンク
}[] = [
  {
    label: "重要事項説明書印刷",
    path: "/assets/pdf/RPT021_重要事項確認書.pdf",
  },
  {
    label: "社会福祉施設職員等退職手当共済法",
    link: "https://elaws.e-gov.go.jp/document?lawid=336AC0000000155",
  },
  {
    label: "社会福祉施設職員等退職手当共済法施行令",
    link: "https://elaws.e-gov.go.jp/document?lawid=336CO0000000286",
  },
  {
    label: "社会福祉施設職員等退職手当共済法施行規則",
    link: "https://elaws.e-gov.go.jp/document?lawid=336M50000100036",
  },
  {
    label: "社会福祉施設職員等退職手当共済約款",
    link: "https://www.wam.go.jp/hp/cat_info_taisyokuteate/guide-taisyokuteate-txt-tabid-239/",
  },
];

const checkList: TkCheckboxProps[] = [
  { label: "法令に基づいて運営されている公的制度であること（重要事項１）" },
  { label: "賦課方式により毎年度掛金を納付すること（重要事項２）" },
  {
    label:
      "退職手当共済契約の申込みができる経営者が限定されていること（重要事項３）",
  },
  {
    label:
      "退職手当共済契約締結時の施設・事業・職員を認識していること（重要事項４）",
  },
  { label: "４月１日の被共済職員の重要性（重要事項５）" },
  { label: "本俸月額（俸給表の額・俸給の調整額）の重要性（重要事項６）" },
  { label: "被共済職員期間について（重要事項７）" },
  { label: "共済契約者には様々な義務があること（重要事項８）" },
  { label: "被共済職員期間の通算及び合算について（重要事項９）" },
  { label: "退職手当共済契約解除について（重要事項１０）" },
  { label: "退職手当共済契約申し込みの手順について（重要事項１１）" },
  { label: "退職手当共済契約締結日について（重要事項１２）" },
  { label: "退職手当共済システムの利用について（重要事項１３）" },
];

export { documentList, checkList };
